import React from "react";
import bgImg from "../Images/image10.jpeg";
import { LiaCertificateSolid } from "react-icons/lia";
import { useNavigate } from "react-router-dom";

const Hero = () => {
    const navigate = useNavigate();
  return (
    <section
      className="container-fluid"
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "90vh",
      }}
    >
      {/* IMPORTANT: align-items-start */}
      <div className="row min-vh-100 align-items-start pt-5">

        {/* Yellow Square Box */}
 <div className="col-lg-6 col-md-8 col-12 offset-lg-1">

          <div
            className="p-5 mt-n4"
            style={{
              backgroundColor: "#FFC94A",
              maxWidth: "520px",      // square look
              minHeight: "420px",     // control height
            }}
          >
<p
  className="fw-bold d-flex align-items-center gap-2"
  style={{ color: "#224b8f" }}
>
  <LiaCertificateSolid size={22} />
  QUALITY YOU CAN TRUST
</p>


            <h1 className="fw-bold">
              Reliable Supply of <br /> Pump Motors & Pipes
            </h1>

            <p className="mt-3">
              We specialize in supplying high-quality pump motors and pipes
              for residential, agricultural, commercial, and industrial
              applications. Our products are built for durability, efficiency,
              and long-lasting performance.
            </p>

        <button
  className="btn px-4 py-2 mt-3 fw-bold"
  style={{
    backgroundColor: "#224b8f",
    color: "#fff",
    border: "none",
  }}
  onClick={() => navigate("/product")}
>
  VIEW OUR PRODUCTS
</button>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;
